import { Injectable } from '@angular/core';
import {ConfService} from '../conf.service';
import {AdminEnvironmentHandlerService} from '../admin-environment-handler.service';
import {interval} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnerSettingsService {

  private _settingsData: any;
  private _environments: any;
  private _environment: any;
  private _environmentServices: any;

  isDataSet = false;
  isAdminEnvironmentDataSet = false;

  constructor(
      private confPost: ConfService,
      private adminEnvironmenthandler:  AdminEnvironmentHandlerService
  ) { }

  get settingsData(): any {
    return this._settingsData;
  }

  set settingsData(value: any) {
    this._settingsData = value;
  }

  get environments(): any {
    return this._environments;
  }

  set environments(value: any) {
    this._environments = value;
  }

  get environment(): any {
    return this._environment;
  }

  set environment(value: any) {
    this._environment = value;
  }

  get environmentServices(): any {
    return this._environmentServices;
  }

  set environmentServices(value: any) {
    this._environmentServices = value;
  }

  hasPartnerSettingsDataSet(): Boolean {
    return this.isDataSet;
  }

  changeEnvironment() {
    if (this.settingsData && this.settingsData['environments']) {
      this.environments = this.settingsData['environments'];
      if (this.environments) {
        this.environment = this.environments.find(environment => environment.name === this.adminEnvironmenthandler.currentEnvironment['env']);
        this.environmentServices = this.environment['services'];
      }
    }
  }

  initializePartnerSettings() {
    return new Promise((resolve, reject) => {
      const adminEnvironmentSettingsSubscription = interval(500).subscribe((async x => {
        if (this.adminEnvironmenthandler.hasAdminEnvironmentSettingsDataSet()) {
          adminEnvironmentSettingsSubscription.unsubscribe();
          if (!this.settingsData) {
            this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false)
                .subscribe(data => {
                  this.settingsData = data['body'][0];
                  if (this.settingsData && this.settingsData['environments']) {
                    this.environments = this.settingsData['environments'];
                    if (this.environments) {
                      this.environment = this.environments.find(environment => environment.name === this.adminEnvironmenthandler.currentEnvironment['env']);
                      if (this.environment) {
                        this.environmentServices = this.environment['services'];
                      }
                    }
                  }
                  if (this.settingsData && this.environments && this.environment && this.environmentServices && this.adminEnvironmenthandler.currentEnvironment) {
                    this.isDataSet = true;
                  } else {
                    this.isDataSet = false;
                  }
                });
          }
          this.isAdminEnvironmentDataSet = true;
          resolve(true);
        } else {
          this.adminEnvironmenthandler.initAdminEnvironment();
          this.isAdminEnvironmentDataSet = false;
          resolve(false);
        }
      }));
    });
  }

  initPartnerSettings() {
    const adminEnvironmentSettingsSubscription = interval(500).subscribe((async x => {
      if (this.adminEnvironmenthandler.hasAdminEnvironmentSettingsDataSet()) {
        adminEnvironmentSettingsSubscription.unsubscribe();
        if (!this.settingsData) {
          this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false)
              .subscribe(data => {
                this.settingsData = data['body'][0];
                if (this.settingsData && this.settingsData['environments']) {
                  this.environments = this.settingsData['environments'];
                  if (this.environments) {
                    this.environment = this.environments.find(environment => environment.name === this.adminEnvironmenthandler.currentEnvironment['env']);
                    if (this.environment) {
                      this.environmentServices = this.environment['services'];
                    }
                  }
                }
                if (this.settingsData && this.environments && this.environment && this.environmentServices && this.adminEnvironmenthandler.currentEnvironment) {
                  this.isDataSet = true;
                } else {
                  this.isDataSet = false;
                }
              });
        }
        this.isAdminEnvironmentDataSet = true;
      } else {
        this.adminEnvironmenthandler.initAdminEnvironment();
        this.isAdminEnvironmentDataSet = false;
      }
    }));
  }
}
